import { useEffect, useRef } from "react";
import { Application, Assets, Sprite } from "pixi.js";

import trackPng from "../../assets/cplogo_track.png";
import stationsPng from "../../assets/cplogo_stations.png";
import crosstownPng from "../../assets/cplogo_crosstown.png";
import publicPng from "../../assets/cplogo_public.png";

import "./cplogo.css";

// COLOR PICKER //
function pickRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

export default function CPLogo({
    size = 200,
    className = ""
}) {
    const pixiRef = useRef(null);

    useEffect(() => {
        let app;

        async function initPixi() {
            const SOURCE_WIDTH = 844;
            const SOURCE_HEIGHT = 340;
            const DISPLAY_HEIGHT = size;
            const DISPLAY_WIDTH = SOURCE_WIDTH * (DISPLAY_HEIGHT / SOURCE_HEIGHT);
            const LOGO_SCALE = DISPLAY_HEIGHT / SOURCE_HEIGHT;

            const trackColors = [
                0x0092d0,
                0x7500d0,
                0xff9288,
                0xd06900,
                0xa2001f,
                0x0da200,
                0x8b4200,
                0xe7b600,
            ];

            const crosstownColors = [
                0xc28155,
                0xf0d0c7
            ];

            const publicColors = [
                0xff8f93,
                0x8febff,
                0xfff9f5,
                0x000000
            ];



            app = new Application();

            await app.init({
                width: DISPLAY_WIDTH,
                height: DISPLAY_HEIGHT,
                backgroundAlpha: 0,
                antialias: true,
                resolution: 2,
                autoDensity: false,
            });

            pixiRef.current.appendChild(app.canvas);

            const [
                trackTexture,
                stationsTexture,
                crosstownTexture,
                publicTexture,
            ] = await Promise.all([
                Assets.load(trackPng),
                Assets.load(stationsPng),
                Assets.load(crosstownPng),
                Assets.load(publicPng)
            ]);

            const centerX = DISPLAY_WIDTH / 2;
            const centerY = DISPLAY_HEIGHT / 2;

            const makeSprite = (texture) => {
                const sprite = new Sprite(texture);
                sprite.anchor.set(0.5);
                sprite.scale.set(LOGO_SCALE);
                sprite.x = centerX;
                sprite.y = centerY;
                return sprite;
            };

            const trackSprite = makeSprite(trackTexture);
            trackSprite.tint = pickRandom(trackColors);
            trackSprite.alpha = 0.8;

            const stationsSprite = makeSprite(stationsTexture);
            stationsSprite.tint = 0xffffff;
            stationsSprite.alpha = 0.9;

            const crosstownSprite = makeSprite(crosstownTexture);
            crosstownSprite.tint = pickRandom(crosstownColors);
            
            const publicSprite = makeSprite(publicTexture);
            publicSprite.tint = pickRandom(publicColors);

            app.stage.addChild(
                trackSprite,
                stationsSprite,
                crosstownSprite,
                publicSprite
            );

            // app.stage.addChild(makeSprite(trackTexture));
            // app.stage.addChild(makeSprite(stationsTexture));
            // app.stage.addChild(makeSprite(crosstownTexture));
            // app.stage.addChild(makeSprite(publicTexture));
        }

        initPixi();

        return () => {
            if (app) app.destroy(true);
        };
    }, [size]);

    return (
        <div
            className={`cplogo ${className}`}
            ref={pixiRef}
        ></div>
    );
}